import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EMPTY } from 'rxjs';

import { SsoOptionsService } from './sso-options.service';
import { CbreLogger, CbreLoggerToken } from '@cbre/logger';

@Injectable()
export class LoginRedirectService {
  constructor(
    private ssoOptions: SsoOptionsService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(CbreLoggerToken) private logger: CbreLogger
  ) {}

  public redirectWithState() {
    const { redirectUrl } = this.ssoOptions.options;
    const nextUrl = `${redirectUrl}${this.appendStateParam}`;
    this.logger.debug(`redirectWithState ${nextUrl}`);
    this.document.location = nextUrl;
    return EMPTY; // returning EMPTY to prevent multiple redirections.
  }

  private get appendStateParam() {
    const currentPath = this.document.location.pathname;
    if (['', '/'].some(p => p === currentPath) || currentPath?.includes('adfs-callback')) {
      return '';
    }
    return `?state=${currentPath}`;
  }
}
